import React from 'react';
import { MultiSelectSuggest } from 'lib/MultiSelectSuggest';
import { Option } from 'lib/types';

interface CreatableSelectProps {
    placeholder?: string;
    value: Option;
    onChange: (value: Option) => void;
    options: Option[];
    onCreate: (value: string) => void;
}

const CreatableSelectComponent: React.FC<CreatableSelectProps> = ({
    placeholder,
    value,
    onChange,
    options,
    onCreate
}) => {
    const [inputValue, setInputValue] = React.useState('');
    const handleInputChange = React.useCallback((value: string) => {
        setInputValue(value);
    }, []);
    const handleKeyDown = React.useCallback(
        (event: React.KeyboardEvent<HTMLElement>) => {
            if (!inputValue) {
                return;
            }
            switch (event.key) {
                case 'Enter':
                case 'Tab':
                    setInputValue('');
                    onCreate(inputValue);
                    event.preventDefault();
            }
        },
        [inputValue, onCreate]
    );
    return (
        <MultiSelectSuggest
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            value={value}
            isMulti={false}
            onChange={onChange}
            options={options}
            onInputChange={handleInputChange}
            isCreatable
        />
    );
};

export const CreatableSelect = React.memo(
    CreatableSelectComponent,
    (prev, next) =>
        ((!prev.value && !next.value) ||
            (prev.value && prev.value.value) === (next.value && next.value.value)) &&
        prev.placeholder === next.placeholder &&
        prev.options === next.options
);
